import { theme as chakraTheme, extendTheme } from '@chakra-ui/react';
import { css } from '@emotion/css';
import { rgba, darken, lighten } from 'polished';

const font = `Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`;

const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);
const customPrimaryColor = params.get('primaryColor');
const customSecondaryColor = params.get('secondaryColor');
const customTertiaryColor = params.get('tertiaryColor');

const extendedConfig = {
  ...chakraTheme,
  styles: {
    ...chakraTheme.styles,
    global: {
      ...chakraTheme.styles.global,
      '#root': {
        h: '100dvh',
        display: 'flex',
        flexDir: 'column',
      },
    },
  },
  fonts: {
    ...chakraTheme.fonts,
    body: font,
    heading: font,
  },
  colors: {
    ...chakraTheme.colors,
    main: customPrimaryColor || '#587AFF',
    secondary: `${rgba(customPrimaryColor || '#587AFF', 0.11)}`,
    tertiary: customTertiaryColor || '#FFFFFF',
    inputStroke: '#A0AEC0',
    buttonStroke: '#D5D8DA',
    background: '#FFFFFF',
    error: 'red',
    primaryDark: customPrimaryColor ? `${darken(0.37, customPrimaryColor)}` : '#001F97',
    primaryLight: customPrimaryColor ? `${lighten(0.29, customPrimaryColor)}` : '#EDF1FF',
    greyNatural: '#828282',
    greyDark: '#718096',
    gray: {
      ...chakraTheme.colors.gray,
      500: '#D2D2D2',
    },
  },
  fontSizes: {
    ...chakraTheme.fontSizes,
    title: '16px',
    chatText: '14px',
    chatSmallText: '12px',
    chatTinyText: '10px',
  },
  fontWeights: {
    ...chakraTheme.fontWeights,
    normal: 400,
    medium: 600,
    bold: 800,
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: customSecondaryColor,
          color: customPrimaryColor,
          fontSize: 'chatSmallText',
          fontWeight: '700',
          borderRadius: '8px',
          px: '12px',
          py: '8px',
          boxShadow: '0 6px 12px -2px rgba(50,50,93,0.25), 0 3px 7px -3px rgba(0,0,0,0.3)',
          transition: 'background-color 0.35s ease, color 0.35s ease',
          _hover: {
            bg: `${customPrimaryColor} !important`,
            color: `${customSecondaryColor} !important`,
            border: `2px solid ${customSecondaryColor}`,
          },
          _active: {
            bg: `${customPrimaryColor} !important`,
            color: `${customSecondaryColor} !important`,
            border: `2px solid ${customSecondaryColor}`,
          },
          _disabled: { bg: '#E3E3E3 !important', color: '#828282 !important' },
        },
        primaryBorderless: {
          bg: customSecondaryColor,
          color: customPrimaryColor,
          fontSize: 'chatSmallText',
          fontWeight: '700',
          borderRadius: '8px',
          px: '12px',
          py: '8px',
          boxShadow: '0 6px 12px -2px rgba(50,50,93,0.18), 0 3px 6px -4px rgba(0,0,0,0.22)',
          transition: 'background-color 0.35s ease, color 0.35s ease',
          _hover: {
            bg: `${customPrimaryColor} !important`,
            color: `${customSecondaryColor} !important`,
            border: 'none',
          },
          _active: {
            bg: `${customPrimaryColor} !important`,
            color: `${customSecondaryColor} !important`,
            border: 'none',
          },
          _disabled: { bg: '#E3E3E3 !important', color: '#828282 !important', border: 'none' },
        },
      },
    },
    Menu: {
      baseStyle: {
        list: { py: '12px' },
        item: {
          color: 'black',
          fontSize: '15px',
          bg: 'none',
          px: '12px',
          _hover: { fontWeight: 700, transition: '0.1s' },
          _disabled: { _hover: { color: 'black' }, fontWeight: '300 !important' },
        },
      },
    },
  },
};
export const theme = extendTheme(extendedConfig);

export const markdownStyles = css`
  &:has(img) {
    width: 100%;
  }
  word-wrap: break-word; /* Older syntax, supported in most browsers */
  overflow-wrap: break-word; /* Standard syntax */
`;
